/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { SOLVE_BANK_ACCOUNT_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(SOLVE_BANK_ACCOUNT_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((payload) =>
      AjaxRequest.open(
        'post',
        `/admin/pendencycustom/pendencies/${payload.id}/bankaccount`,
        payload,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
